export const generateCaptcha = (setCaptcha, canvasRef) => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";

  let text = "";

  for (let i = 0; i < 6; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  setCaptcha(text);

  drawCaptcha(text, canvasRef);
};

export const drawCaptcha = (text, canvasRef) => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");

  canvas.width = 150;
  canvas.height = 50;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Background noise
  for (let i = 0; i < 500; i++) {
    ctx.fillStyle = "rgba(0,0,0,0.2)";
    ctx.fillRect(
      Math.random() * canvas.width,
      Math.random() * canvas.height,
      1,
      1,
    );
  }

  // Text
  ctx.font = "28px Arial";
  ctx.fillStyle = "#000";
  ctx.textBaseline = "middle";

  for (let i = 0; i < text.length; i++) {
    const x = 10 + i * 22;
    const y = canvas.height / 2;

    const angle = (Math.random() - 0.5) * 0.4;

    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.fillText(text[i], 0, 0);
    ctx.restore();
  }
};
